module.exports = __webpack_public_path__ + "img/title1.b96d55f5.png";